<script setup lang="ts">
import { ref, Ref, toRefs } from 'vue';
import InputSwitch from 'primevue/inputswitch';
import GoalsCheckbox from './GoalsCheckbox.vue';
import { TrialGoalInterface } from '@/types';
import { EMIT } from '@/enum';

interface PropsInterface {
  goal: TrialGoalInterface;
  attendeeId: number;
  displayPastEventsModal: boolean;
}

const emit = defineEmits<{
  (eventName: EMIT.SHOULD_SAVE_GOALS, showPercentGoals: boolean, goalId: number, attendeeId: number): void;
}>();

const props = defineProps<PropsInterface>();
const { goal, attendeeId, displayPastEventsModal } = toRefs(props);
const showTrialGoals: Ref<boolean> = ref(goal.value.show_goal);

const updateShouldSaveGoals = () => {
  emit(EMIT.SHOULD_SAVE_GOALS, showTrialGoals.value, goal.value.treatment_goal_id, attendeeId.value);
};
</script>

<template>
  <div class="flex flex-column goal-card p-3 mt-3" :class="{ disabled: !showTrialGoals }">
    <div class="w-full flex flex-row justify-content-between align-items-start mb-3">
      <div class="description mr-2">
        <b>{{ goal.description }}</b>
      </div>
      <div>
        <InputSwitch
          v-model="showTrialGoals"
          class="mt-1"
          :disabled="!!goal.completed_at"
          @change="updateShouldSaveGoals"
        />
      </div>
    </div>
    <template v-if="showTrialGoals">
      <GoalsCheckbox
        :trial="goal"
        :attendee-id="attendeeId"
        :disabled="!!goal.completed_at"
        :display-past-events="displayPastEventsModal"
      />
    </template>
  </div>
</template>

<style lang="scss" scoped>
.disabled.goal-card {
  background: white;
  border: 2px solid $grayLight;
}
.description {
  font-size: 14px;
  line-height: 18px;
}
</style>
